module.exports = __webpack_public_path__ + "assets/img/a-1_fanhuiqianye.3b5f661a.svg";